import { post } from "../../api/HttpClient.js";
import { BASE_URL, MapBasedBooking_url, QuickBookingInfo_url, SpotAvailability_url } from "../../config/ApiConfig.js";
import { AppConstant } from "../../config/AppConstants.js";
import { getGuId } from "../../utils/SecurityService.js";

export const QuickBookingInfo_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceID = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${QuickBookingInfo_url}`,
        params: requestParams,
    });
};

export const SpotAvailability_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceID = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${SpotAvailability_url}`,
        params: requestParams,
    });
};

export const MapBasedBooking_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceID = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.TeamLeaderGuId = getGuId();
    return post({
        url: `${BASE_URL}${MapBasedBooking_url}`,
        params: requestParams,
    });
};
